import { useQueryClient } from '@tanstack/react-query';

import { type CollectionSalesVolumeArgs, getQueryString } from '@pkg/hooks';

import { callGetCollectionSalesVolume } from '@app/client/resources/daas';

export function useCollectionSalesVolume() {
    const queryClient = useQueryClient();
    return async ({ slugs, startDate, endDate, chain }: CollectionSalesVolumeArgs) => {
        const chainSlugs = slugs?.map((s) => `${chain}.${s}`);
        const query = {
            start_date_inclusive: true,
            end_date_inclusive: true,
        };
        const customQueryString = getQueryString({
            queryArrayKey: 'slugs',
            queryArray: chainSlugs,
            queryParams: query,
        });

        const cache = ['collection-stats', customQueryString];
        const salesRes = await queryClient.ensureQueryData({
            queryKey: cache,
            queryFn: ({ signal }) =>
                callGetCollectionSalesVolume({
                    settings: { signal },
                    customQuery: `${customQueryString}&start_date=${startDate}&end_date=${endDate}`,
                }),
        });
        if (salesRes?.ok && salesRes.value && chain) {
            return salesRes.value[chain];
        }
    };
}
